import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrar = ({ descricao, cd_aplicativo, idc_status }) => {
  return axios.post(
    process.env.URL_API_BASE + '/aplicativo-segmento',
    {
      descricao: descricao,
      cd_aplicativo: cd_aplicativo,
      idc_status: idc_status,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const alterar = ({ id, descricao, cd_aplicativo, idc_status }) => {
  return axios.patch(
    process.env.URL_API_BASE + '/aplicativo-segmento/' + id,
    {
      descricao: descricao,
      cd_aplicativo: cd_aplicativo,
      idc_status: idc_status,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listar = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/aplicativo-segmento',
    config
  )
  return response.data
}

const listarPorAplictivo = async aplicativo => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/aplicativo-segmento/listar-por-aplicativo/' +
      aplicativo,
    config
  )
  return response.data
}

export const obter = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/aplicativo-segmento/' + id,
    config
  )
  return response.data
}

export default {
  cadastrar,
  alterar,
  listar,
  listarPorAplictivo,
  obter
}



// WEBPACK FOOTER //
// ./src/actions/AplicativoSegmentoActions.js